import React, { Component } from "react";
import { connect } from "react-redux";
import { Col } from 'reactstrap';
import { Permissions } from '@autofact-lib/operation-lib-model-notary-platform';
import AuthService from '../../services/AuthService';
import BackendApiService from '../../services/BackendApiService';
import { changeBillingCount, changeSaleNotesCount } from '../../store/dispatchers/app';
import { buildBillingFilters, buildSaleNoteFilters } from '../../helpers/filterBuilder';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { NavLink as RRNavLink, withRouter, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaUserTie } from "react-icons/fa";

import Footer from '../../components/footer/Footer';
import DataModal from '../../components/data-modal/DataModal';
import logo from "../assets/logo_af_pro.svg";

class MainLayout extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.toggleExecutiveModal = this.toggleExecutiveModal.bind(this);
    this.loadExecutiveData = this.loadExecutiveData.bind(this);
    this.state = {
      isOpen: false,
      dropdownOpen: false,
      loadedTabTotals: false,
      executiveModalOpen: false,
      executiveData: null,
      loadingExecutive: false,
      hasExecutiveData: null,
    };
  }

  loadTabTotals() {

    if (this.props.userData.afpr_us_logged_in && this.state.loadedTabTotals === false) {
      console.log('loading totals from main layout');
      if (this.props.location.pathname !== '/facturas') {
        BackendApiService.getPaymentDocuments(buildBillingFilters(this.props.userData)).then(data => {
          if (data.extra && data.extra.recordsTotal > 0){
            changeBillingCount(data.extra.recordsTotal);
          }
        }).catch(console.error);
      }

      if (this.props.location.pathname !== '/cierres') {
        BackendApiService.getPaymentDocuments(buildSaleNoteFilters(this.props.userData)).then(data => {
          if (data.extra && data.extra.recordsTotal > 0){
            changeSaleNotesCount(data.extra.recordsTotal);
          }
        }).catch(console.error);
      }
      this.setState({
        loadedTabTotals: true,
      });

    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  toggleDropdown() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  toggleExecutiveModal() {
    this.setState(prevState => ({
      executiveModalOpen: !prevState.executiveModalOpen
    }));
  }

  async loadExecutiveData() {
    if (!this.props.userData.afpr_us_logged_in || this.state.loadingExecutive || this.state.executiveData || this.state.hasExecutiveData !== null) {
      return;
    }

    this.setState({ loadingExecutive: true });

    try {
      const userData = this.props.userData || {};
      const user = userData.usuario || {};
      const company = user.empresa || {};
      const companyId = company.grupo_empresa_idgrupo_empresa;

      if (companyId) {
        const executiveData = await BackendApiService.getCollectionResponsibleByCompany(companyId);
        const hasData = executiveData && (executiveData.name || executiveData.email || executiveData.phone);
        
        this.setState({ 
          executiveData: executiveData,
          loadingExecutive: false,
          hasExecutiveData: hasData
        });
      } else {
        this.setState({ 
          loadingExecutive: false,
          hasExecutiveData: false 
        });
      }
    } catch (error) {
      this.setState({ 
        loadingExecutive: false,
        hasExecutiveData: false 
      });
    }
  }

  getExecutiveModalData() {
    const executive = this.state.executiveData;
    if (!executive) {
      return [];
    }
    const fullName = `${executive.name} ${executive.last_name} ${executive.second_last_name}`.trim();

    return [
      {
        label: "Nombre",
        value: fullName,
        type: "text"
      },
      {
        label: "Correo",
        value: executive.email,
        type: "email"
      },
      {
        label: "Teléfono",
        value: executive.phone,
        type: "phone"
      }
    ];
  }

  render() {
    const loginInfo = this.props.userData || {};
    const userData = loginInfo.usuario || {};
    const user = userData || {};
    const invoiceCenter = user.centro_facturacion || {};
    const invoiceCenterData = invoiceCenter || {};
    const invoiceCenterName = invoiceCenterData.nombre_corto || "-";
    this.loadTabTotals();
    this.loadExecutiveData();
    return (
      <div className="wrapper">
        <Navbar color="dark" dark expand="md" className={"bg-primary-darker"}>
          <NavbarBrand to="/" tag={RRNavLink}>
            <img src={logo} alt="Autofact Pro Logo" style={{width:200, height:50}}/>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <div className="ml-auto">
              <Nav navbar>
                <div className="navbar-menu">
                  <NavItem>
                    <NavLink
                      to="/facturas"
                      activeClassName="active"
                      tag={RRNavLink}
                    >
                      Facturas ({this.props.billingCount})
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      to="/cierres"
                      activeClassName="active"
                      tag={RRNavLink}
                    >
                      Cierres ({this.props.saleNotesCount})
                    </NavLink>
                  </NavItem>
                  {AuthService.canDo(Permissions.COLLECTION_SEE_PROVISION_CLOSURE) && <NavItem>
                    <NavLink
                      to="/banco"
                      activeClassName="active"
                      tag={RRNavLink}
                    >
                      Banco
                    </NavLink>
                  </NavItem>


                  }
                  <NavItem>
                    <NavLink
                      to="/contacto-facturacion"
                      activeClassName="active"
                      tag={RRNavLink}
                    >
                      Datos facturación
                    </NavLink>
                  </NavItem>
                  
                  {this.state.hasExecutiveData && (
                    <NavItem>
                      <NavLink
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.toggleExecutiveModal();
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <FaUserTie className="mr-2 mb-1" style={{ fontSize: '0.75em' }} />
                        Mi ejecutivo
                      </NavLink>
                    </NavItem>
                  )}
                </div>
                <div className="navbar-session">
                  {
                    this.props.isLoggedIn ?
                      <NavItem className="navbar-emp text-center">
                        <NavLink>
                          <FontAwesomeIcon icon="building" />
                          <span className="emp-name">{invoiceCenterName}</span>
                        </NavLink>
                        <Col md={12} className="text-white pl-2 pr-2">
                          {user.mail || 'Desconocido'}
                        </Col>
                      </NavItem>
                      :
                      <span></span>
                  }
                  <NavItem>
                    <Dropdown
                      isOpen={this.state.dropdownOpen}
                      toggle={this.toggleDropdown}
                    >
                      <DropdownToggle caret nav>
                        <FontAwesomeIcon icon="user" />
                      </DropdownToggle>
                      <DropdownMenu right>
                        {this.props.isLoggedIn ? (
                          <div>
                            <DropdownItem>
                              <Link to="/logout" className="dropdown-link">
                                <FontAwesomeIcon icon="sign-out-alt" />
                                Cerrar Sesión
                              </Link>
                            </DropdownItem>
                          </div>
                        ) : (
                            <DropdownItem>
                              <Link to="/login" className="dropdown-link">
                                <FontAwesomeIcon icon="sign-in-alt" />
                              Iniciar Sesión
                            </Link>
                            </DropdownItem>
                          )}
                      </DropdownMenu>
                    </Dropdown>
                  </NavItem>
                </div>
              </Nav>
            </div>
          </Collapse>
        </Navbar>
        <div className={"main-container"}>{this.props.children}</div>
        <Footer />
        
        <DataModal 
          isOpen={this.state.executiveModalOpen}
          toggle={this.toggleExecutiveModal}
          title="Mi ejecutivo de cobranza"
          data={this.getExecutiveModalData()}
        />
      </div>
    );
  }
}
export default withRouter(
  connect(store => ({
    billingCount: store.app.billingCount,
    saleNotesCount: store.app.saleNotesCount,
    closureCount: store.app.closureCount,
    userData: store.app.userData
  }))(MainLayout)
);
